import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import LoggedInContainer from './LoggedInContainer';
import ExtensionInfoContainer from './ExtensionInfoContainer';
import MobileDownloadInfo from '../login_view/MobileDownloadInfo';

import './CongratsContent.css';

const DOWNLOAD_INFO_TITLE = 'Create your Avatar';
const DOWNLOAD_INFO_TEXT = 'Install the Bitmoji app and Log in with Snapchat to create your avatar.';
class CongratsContent extends Component {
    render() {
        const { avatarId } = this.props;

        return (
            <div className="congrats-content">
                <LoggedInContainer avatarId={avatarId} />
                { avatarId ?
                    <ExtensionInfoContainer avatarId={avatarId} />
                    :  <MobileDownloadInfo title={DOWNLOAD_INFO_TITLE}
                                           text={DOWNLOAD_INFO_TEXT} /> }

            </div>
        );
    }
}

CongratsContent.propTypes = {
    avatarId: PropTypes.string.isRequired
};

export default CongratsContent;



// WEBPACK FOOTER //
// ./src/components/congrats_view/CongratsContent.js